import { StaticPage } from '@dreamstack/payload/src/payload-types'
import { cn } from '@dreamstack/util/src/cn'
import type { FunctionComponent } from 'react'
import type { HeroSize } from './HeroContainer'
import { HeroContainer } from './HeroContainer'

const baseBlockerClass =
  'w-full flex-shrink-0 bg-transparent -mt-px-128 sm:-mt-[132px] md:-mt-[150px] lg:-mt-px-196'

const sizeClassByHero: Record<NonNullable<HeroSize>, string> = {
  large: 'h-px-480 md:h-px-576 lg:h-px-1080',
  medium: 'h-px-320 md:h-px-576 lg:h-px-860',
  small: 'h-px-320 md:h-px-480 lg:h-px-480',
  international: 'h-px-480 text-center md:h-[798px]',
  campaign: 'h-px-320 md:h-[503px] ml:h-[798px]',
}

const TransparentSpaceBlocker = ({
  size,
  noMarginBottom,
}: {
  size?: HeroSize
  noMarginBottom: boolean
}) => (
  <div
    className={cn(
      baseBlockerClass,
      size && sizeClassByHero[size],
      !noMarginBottom && 'mb-px-64 md:mb-px-80 lg:mb-px-96'
    )}
  />
)

export type HeroProps = StaticPage['hero'] & {
  size?: HeroSize
  forceDarkBg?: boolean
  noMarginBottom?: boolean
}

export const Hero: FunctionComponent<React.PropsWithChildren<HeroProps>> = ({
  backgroundImage,
  title,
  subtitle,
  size,
  forceDarkBg = true,
  noMarginBottom = false,
}) => {
  return (
    <>
      <TransparentSpaceBlocker size={size} noMarginBottom={noMarginBottom} />
      <HeroContainer
        backgroundImage={backgroundImage}
        title={title}
        subtitle={subtitle}
        forceDarkBg={forceDarkBg}
        size={size}
        noMarginBottom={noMarginBottom}
      />
    </>
  )
}
